import {reachGoal, YM_GOALS} from 'shared/lib/analytics';
import {useCreateGate} from 'entities/tariff';

import useCanCreateHttpMonitor from './useCanCreateHttpMonitor';

export const useCreateHttpMonitorButton = () => {
    const {open, close, isCreateOpen, isExceededOpen} = useCreateGate(useCanCreateHttpMonitor());

    const handleOpen = () => {
        open();
        reachGoal(YM_GOALS.ADD_MONITOR);
    };

    return {isCreateOpen, isExceededOpen, handleOpen, handleClose: close};
};

export default useCreateHttpMonitorButton;
